import { ADVERTISEMENTURL } from "helpers/constant";
import { callApi } from "Apis";

export async function advertisementList(data) {
  try {
    const response = await callApi({ url: ADVERTISEMENTURL.LIST, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function advertisementAdd(data) {
  try {
    const response = await callApi({ url: ADVERTISEMENTURL.ADD, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function getAdvertisementById(id) {
  try {
    const response = await callApi({ url: ADVERTISEMENTURL.GET(id), method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function updateAdvertisement(data) {
  try {
    const response = await callApi({ url: ADVERTISEMENTURL.UPDATE, body: data, method: "PUT" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function deleteAdvertisementById(id) {
  try {
    const response = await callApi({ url: ADVERTISEMENTURL.DELETE(id), method: "DELETE" });
    return response;
  } catch (err) {
    throw err;
  }
}
